import React from 'react';
import Proptypes from 'prop-types';
import { Grid, TextField } from '@mui/material';
import SelectInput from './SelectInput';
import { countryOptions } from '../constants/profileData';

function PhoneNumberInput(props) {
	// let wrapperClass = 'form-group mt-2';
	// if (props.error && props.error.length > 0) wrapperClass += ' has-error';
	return (
		<Grid container>
			<Grid item xs={3}>
				<SelectInput
					name={props.countryCodeName}
					label='Country Code'
					value={props.contactNumberCountry}
					handleChange={props.handleChange}
					options={countryOptions.map((option) => {
						return {
							label: option.countryWithCode,
							value: option.dialCode,
						};
					})}
				/>
			</Grid>
			<Grid item xs={9} style={{ paddingLeft: '15%' }}>
				<TextField
					variant='standard'
					label={props.label}
					fullWidth
					required
					type='number'
					name={props.name}
					value={props.contactNumber}
					placeholder={props.placeholder}
					onChange={props.handleChange}
					error={props.contactNumberError}
					helperText={props.helperText}
				/>
			</Grid>
		</Grid>
	);
}

PhoneNumberInput.propTypes = {
	contactNumber: Proptypes.string.isRequired,
	handleChange: Proptypes.func.isRequired,
	contactNumberError: Proptypes.string.isRequired,
	contactNumberhelperText: Proptypes.string.isRequired,
	contactNumberCountry: Proptypes.string.isRequired,
	label: Proptypes.string.isRequired,
	placeholder: Proptypes.string.isRequired,
	name: Proptypes.string.isRequired,
	countryCodeName: Proptypes.string.isRequired,
};

export default PhoneNumberInput;
